import GeoJSON from "ol/format/GeoJSON";
import { FeatureType } from "@/geoMap/define/FeatureType";
import { IAttributeConvert } from "./IAttributeConvert";
import { AttributeView } from "./AttributeView";
import { AttributeValue } from "./AttributeValue";
import { ExportValue } from "./ExportValue";

/**
 * 対象地物タイプ
 */
const FEATURE_TYPE = FeatureType.DrmLink;

/**
 * 画面幅
 */
const VALUE_WIDTH = 400;

/**
 * 画面高さ
 */
const VALUE_HEIGHT = 300;

/**
 * タイトル
 */
const VALUE_TITLE = "DRM-DB属性表示（リンク）";

/**
 * 出力JSONファイル名
 */
const VALUE_JSON_FILE_NAME = "drm_link_yyyyMMdd_HHmmss.geojson";

/**
 * 出力CSVファイル名
 */
const VALUE_CSV_FILE_NAME = "drm_link_yyyyMMdd_HHmmss.csv";

/**
 * 属性データ
 */
const PROPERTY_MAP = [
  { key: "リンク番号", isSimple: true },
  { key: "主路線・管理者コード", isSimple: true },
  { key: "主路線・道路種別コード", isSimple: true },
  { key: "主路線・路線番号", isSimple: true },
  { key: "リンク長（計算値）", isSimple: true },
];

/**
 * DRMリンク属性変換クラス
 */
export class DRMLinkAttributeConvert implements IAttributeConvert {
  /**
   * 対象GeoJSON
   */
  private _geoJson: any;

  /**
   * コンストラクタ
   * @param geoJson
   */
  constructor(geoJson: any) {
    this._geoJson = geoJson;
  }
  /**
   * 地物タイプ取得
   */
  getFeatureType(): FeatureType {
    return FEATURE_TYPE;
  }
  /**
   * 画面用フォーマットに変換
   */
  getViewFormatData(): AttributeView {
    const feature = new GeoJSON().readFeature(this._geoJson);
    const attributeValues: AttributeValue[] = [];
    // パーマネントIDのみ表示項目とプロパティ名が異なる
    attributeValues.push({
      key: "パーマネントID",
      value: feature.get("pid") ?? "-",
      isSimple: true,
    });
    PROPERTY_MAP.forEach(({ key }) => {
      attributeValues.push({
        key,
        value: feature.get(key) ?? "-",
        isSimple: true,
      });
    });
    const attributeView = new AttributeView(
      attributeValues,
      VALUE_TITLE,
      VALUE_WIDTH,
      VALUE_HEIGHT,
      null,
      null,
      true,
      true
    );
    return attributeView;
  }

  /**
   * ファイル出力用項目取得
   */
  getExportValue(): ExportValue {
    const feature = new GeoJSON().readFeature(this._geoJson);
    feature.getGeometry().transform("EPSG:3857", "EPSG:4326");
    const attributeValues = this.getViewFormatData().attributeValues;
    return new ExportValue(
      feature,
      attributeValues,
      VALUE_JSON_FILE_NAME,
      VALUE_CSV_FILE_NAME
    );
  }
}
